import { render, staticRenderFns } from "./RegistrationPaymentPage.vue?vue&type=template&id=e8a3fa7e&scoped=true&"
import script from "./RegistrationPaymentPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a3fa7e",
  null
  
)

export default component.exports